import produce from 'immer';
import { AnyAction } from 'redux';

import { ACTION_NAMES } from '../../constants';
import { PublicHolidayTemplate } from '../../types/v3/publicHolidayTemplates';
import { array as arrayUtils } from '../../utils';

const { applyMinimalChangesToArray } = arrayUtils;

type V3LoadPublicHolidayTemplatesInRedux = { publicHolidayTemplates: PublicHolidayTemplate[] };

const initialState = produce({ publicHolidayTemplates: [] }, () => {});

export const v3PublicHolidayTemplatesReducer = (
  state = initialState,
  action: AnyAction
): V3LoadPublicHolidayTemplatesInRedux =>
  produce(state, (draft: V3LoadPublicHolidayTemplatesInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_PUBLIC_HOLIDAY_TEMPLATES}_SUCCESS`: {
        applyMinimalChangesToArray(draft.publicHolidayTemplates, action.result.content);
        break;
      }

      default:
      // nothing to do => immer returns the original object
    }
  });
